// mutation-types.js
export const USER_ID = 'USER_ID'
export const FIRST_NAME = 'FIRST_NAME'
export const LAST_NAME = 'LAST_NAME'
export const USERNAME = 'USERNAME'